import { render, staticRenderFns } from "./RecordModule.vue?vue&type=template&id=2f74c732"
import script from "./RecordModule.vue?vue&type=script&lang=js"
export * from "./RecordModule.vue?vue&type=script&lang=js"
import style0 from "./RecordModule.vue?vue&type=style&index=0&id=2f74c732&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports